export default {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  'AI-CONNECTOR': {
    TITLE: 'Conecta wokap con tu IA',
    SUBTITLE: 'Conecta tu asistente de IA (ChatGPT o Claude) al conector de wokap para que pueda consultar y gestionar tus ofertas y candidat@s por ti. Sin tokens que copiar ni nada que instalar: solo inicias sesión con tu propia cuenta de wokap.',
    INTRO: {
      WHAT_IS_TITLE: '¿Qué es esto?',
      WHAT_IS_BODY: 'Es un "conector" (se llama servidor MCP) que le da a tu asistente de IA la capacidad de leer y gestionar ofertas y candidat@s de wokap. Al conectarlo, tu asistente te pedirá iniciar sesión con tu propia cuenta de wokap — no hay tokens que copiar ni contraseñas compartidas. A partir de ahí, ve y puede hacer exactamente lo mismo que tú verías y podrías hacer entrando a wokap normalmente, y cada acción queda registrada como hecha por ti.',
      WARNING: 'Algunas acciones notifican al candidato o cambian datos reales (por ejemplo descartar un candidato, enviarle una entrevista o publicar una oferta). Tu asistente debería pedirte confirmación antes de hacerlo — revisa siempre lo que te proponga antes de aceptar.',
    },
    WIZARD: {
      STEP_OF: 'PASO {{current}} DE {{total}}',
      STEP_LABELS: {
        CHOOSE: 'Elige tu IA',
        REVIEW: 'Revisa el acceso',
        CONNECT: 'Conecta',
      },
      CANCEL: 'Cancelar',
      BACK: 'Volver',
      NEED_HELP: '¿Necesitas ayuda?',
      STEP_1: {
        TITLE: 'Conecta wokap con tu IA',
        SUBTITLE: 'Selecciona la inteligencia artificial que utilizas.',
        SECURE_NOTE: 'Conexión segura. Inicias sesión con tu propia cuenta de wokap y puedes desconectarla cuando quieras.',
        NEXT: 'Siguiente',
      },
      STEP_2: {
        TITLE: 'Revisa el acceso',
        SUBTITLE: '{{ai}} podrá ayudarte con la información que ya tienes permiso para consultar.',
        PERMISSIONS: {
          OFFERS: {
            TITLE: 'Ofertas y procesos',
            BODY: 'Consultar ofertas activas y conocer el estado de cada proceso.',
            SCOPE: 'Lectura',
          },
          CANDIDATES: {
            TITLE: 'Candidatos e entrevistas',
            BODY: 'Consultar perfiles, respuestas y entrevistas de tus candidatos.',
            SCOPE: 'Lectura',
          },
          ACTIONS: {
            TITLE: 'Acciones autorizadas',
            BODY: 'Realizar únicamente las acciones disponibles para tu usuario, y con tu confirmación en las que notifican a un candidato o publican una oferta.',
            SCOPE: 'Con aprobación',
          },
        },
        ACCOUNT_LABEL: 'Cuenta que se conectará',
        VERIFIED: 'Verificada',
        AUTHORIZE: 'Autorizar y continuar',
      },
      STEP_3: {
        TITLE: 'Conecta wokap con {{ai}}',
        SUBTITLE: 'Sigue estos pasos. Te llevará menos de dos minutos.',
        URL_LABEL: 'Dirección de conexión',
        DONE: 'Ya lo conecté',
        CLAUDE: {
          STEP_1: { TITLE: 'Abre Conectores', BODY: 'En Claude, entra en Configuración y selecciona Conectores.' },
          STEP_2: { TITLE: 'Añade un conector', BODY: 'Pulsa "Añadir conector personalizado".' },
          STEP_3: { TITLE: 'Pega la dirección', BODY: 'Escribe "wokap" como nombre, pega la dirección de conexión de abajo y pulsa Añadir. Claude te pedirá iniciar sesión con tu cuenta de wokap.' },
        },
        CHATGPT: {
          STEP_1: { TITLE: 'Abre Conectores', BODY: 'En ChatGPT, entra en Configuración → Conectores → Configuración avanzada y activa el modo desarrollador.' },
          STEP_2: { TITLE: 'Añade un conector', BODY: 'Pulsa "Crear" y elige conector MCP personalizado.' },
          STEP_3: { TITLE: 'Pega la dirección', BODY: 'Escribe "wokap" como nombre, pega la dirección de conexión de abajo y pulsa Crear. ChatGPT te pedirá iniciar sesión con tu cuenta de wokap.' },
        },
      },
      SUCCESS: {
        TITLE: 'Conexión completada',
        HEADLINE: '¡wokap ya está conectado!',
        SUBTITLE: '{{ai}} ya puede ayudarte con tus procesos de selección.',
        SERVICE_LABEL: 'Servicio conectado',
        ACTIVE: 'Activo',
        TRY_IT: 'Pruébalo con una de estas instrucciones:',
        PROMPT_1: 'Muéstrame las ofertas activas de mi empresa en wokap.',
        PROMPT_2: 'Resume los candidatos inscritos en la oferta de [nombre de la oferta].',
        MANAGE: 'Administrar conexión',
        OPEN_AI: 'Abrir mi IA',
      },
    },
    COPY: 'Copiar',
    COPIED: 'Copiado al portapapeles',
    FAQ: {
      TITLE: 'Problemas frecuentes',
      Q1: 'No veo la opción de "Conectores" en mi asistente',
      A1: 'No todos los asistentes de IA soportan todavía conectores MCP remotos. Revisa que tengas la versión más reciente, o busca "MCP" o "Connectors" en la documentación de tu asistente.',
      Q2: 'Mi asistente no me pide iniciar sesión al pegar la dirección',
      A2: 'Algunos asistentes piden iniciar sesión la primera vez que usas una herramienta de wokap, no al añadir el conector. Prueba a escribirle algo como "¿qué ofertas hay en wokap?".',
      Q3: 'No aparecen las herramientas de wokap en el asistente',
      A3: 'Revisa que el conector se haya guardado y que hayas completado el inicio de sesión cuando te lo pidió. Si sigue sin aparecer, quita el conector y vuelve a añadirlo.',
      Q4: '¿Cómo desconecto wokap de mi asistente?',
      A4: 'Entra en la sección de Conectores de tu asistente, busca "wokap" y elimínalo. El acceso se revoca de inmediato.',
      Q5: 'Sigue sin funcionar',
      A5: 'Copia el mensaje de error exacto y compártelo con tu equipo técnico.',
    },
    HELP: {
      TITLE: '¿Necesitas ayuda?',
      BODY: 'Contacta a tu equipo técnico o a soporte de wokap.',
    },
  },
} as const;
